import OnboardingDialogLayout from "@components/layouts/Onboarding/components/OnboardDialogLayout";
import { OnboardPP } from "@components/utils/Auth";
import { OnboardingDialogStep } from "@components/utils/OnboardingDialog/constants";
import { OnboardingStepProps } from "@components/utils/OnboardingDialog/types";
import { OnboardMode } from "@constants";

interface OnboardStepProps extends OnboardingStepProps {
  defaultMode?: OnboardMode;
}

const OnboardStep = ({ navigate, handleClose, defaultMode, layout }: OnboardStepProps) => {
  return (
    <OnboardingDialogLayout
      layout={layout}
      navigation={{
        close: {
          onClick: handleClose,
        },
      }}
      features={{
        showCloseButton: true,
        showLanguageSelect: true,
        showChatButton: true,
      }}
      variant="welcome"
    >
      <OnboardPP
        defaultMode={defaultMode ?? OnboardMode.LOGIN}
        onLogin={() => navigate(OnboardingDialogStep.Login)}
        onRegister={() => navigate(OnboardingDialogStep.Register)}
      />
    </OnboardingDialogLayout>
  );
};

export default OnboardStep;
